import { render, staticRenderFns } from "./LeadStatus.vue?vue&type=template&id=24acb31d&scoped=true&"
import script from "./LeadStatus.vue?vue&type=script&lang=js&"
export * from "./LeadStatus.vue?vue&type=script&lang=js&"
import style0 from "./LeadStatus.vue?vue&type=style&index=0&id=24acb31d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24acb31d",
  null
  
)

export default component.exports